module.exports = __webpack_public_path__ + "static/Logo_Light-1a182967399d9b0d39642bafda38bf19.png";